import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import * as RB from "react-bootstrap";
import * as utils from "../../../Utils/comman";
import moment from "moment";
import { setExpId } from "../../../reducers/expIdSlice";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { fetchTravelExpenses } from "../../../reducers/travelExpensesSlice";
import { fetchExpensePlans } from "../../../reducers/expenseSlice";
import { clearExp, setExp } from "../../../reducers/updateExpenseSlice";

function MiscMonthlyLimit({ head, userPermissions, openAccordionId }) {
  const [hasPermission, setHasPermission] = useState(false);
  const [formData, setFormData] = useState({
    natureOfExpense: "",
    date: null,
    amount: "",
    description: "",
    document: [],
  });
  const [validated, setValidated] = useState(false);
  const [isSubmit, setIsSubmit] = useState(false);
  const [amountError, setAmountError] = useState("");
  const dispatch = useDispatch();
  const expId = useSelector((state) => state.expId);
  const [isDocDragging, setIsDocDragging] = useState(false);
  const [isDraggingOver, setIsDraggingOver] = useState(false);
  const [isValidImage, setisValidImage] = useState(false);
  const [isValidDoc, setisValidDoc] = useState(false);
  const [isImage, setIsImage] = useState(false);
  const [error, setError] = useState(false);
  const { expenses } = useSelector((state) => state.expenses);
  const updateExp = useSelector((state) => state.updateExp.updateExp);

  useEffect(() => {
    if (Object.keys(updateExp).length > 0) {
      console.log(updateExp);
      setFormData({
        natureOfExpense: updateExp.nature_of_expense,
        date: null,
        amount: updateExp.amount,
        description: updateExp.description,
        document: [],
      });
    }
  }, [updateExp]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.stopPropagation();
      setValidated(true);
    } else {
      // if (formData.document.length < 1) {
      //   setIsImage(true);
      //   return;
      // } else {
      //   setIsImage(false);
      // }
      setIsSubmit(true);
    }
  };

  const page = 0;
  const countPerPage = 0;
  useEffect(() => {
    if (isSubmit) {
      var bodyFormData = new FormData();
      if (Object.keys(updateExp).length > 0) {
        bodyFormData.append("id", updateExp.id);
      }
      bodyFormData.append("expense_type", "travel");
      bodyFormData.append("planId", openAccordionId);
      bodyFormData.append("headId", head.head_id);
      bodyFormData.append("subHeadId", 0);
      bodyFormData.append("classId", 0);
      bodyFormData.append(
        "dateFrom",
        moment(formData.date).format("YYYY-MM-DD")
      );
      bodyFormData.append("dateTo", "");
      bodyFormData.append("stationFrom", "");
      bodyFormData.append("stationTo", "");
      bodyFormData.append("hotelName", "");
      bodyFormData.append("tollAmount", formData.amount || "0.00");
      bodyFormData.append("amount", formData.amount || "0.00");
      bodyFormData.append("expId", expId || "");
      bodyFormData.append("description", formData.description || "");
      bodyFormData.append("city", "");
      bodyFormData.append("nature_of_expense", formData.natureOfExpense || "");
      formData.document.forEach((doc, index) => {
        bodyFormData.append(`expense_images[]`, doc);
      });

      utils
        .callAPI("post", `/expense/save`, bodyFormData)
        .then((res) => {
          if (typeof res !== "undefined") {
            dispatch(setExpId(res.expId));
            dispatch(clearExp());
            setIsSubmit(false);
            setFormData({
              natureOfExpense: "",
              date: null,
              amount: "",
              description: "",
              document: [],
            });
            setValidated(false);
            setAmountError("");
            dispatch(fetchTravelExpenses({ page, countPerPage }));
            dispatch(
              fetchExpensePlans({ expenseId: expId, planId: openAccordionId })
            );
          } else {
            setIsSubmit(false);
          }
        })
        .catch((err) => {
          setIsSubmit(false);
        });
    }
  }, [isSubmit]);

  useEffect(() => {
    const permission = userPermissions.find(
      (permission) =>
        permission.head_id === head.head_id && permission.sub_head_id === "0"
    );
    setHasPermission(!!permission);
  }, [head, userPermissions]);

  if (!hasPermission) {
    return <div>No permissions to add Misc. Monthly Limit expenses.</div>;
  }

  const handleDateChange = (date) => {
    setFormData({ ...formData, date });

    const selectedDate = moment(date);
    const travelEntitlementRanges = expenses?.result
      .flatMap((expense) => expense.expList)
      .filter((expenseItem) => expenseItem.headId === "2")
      .map((expenseItem) => ({
        dateFrom: expenseItem.dateFrom,
      }));

    const isDateInRange = travelEntitlementRanges.some((range) =>
      selectedDate.isSame(range.dateFrom, "day")
    );

    if (isDateInRange) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "This date is already used for Local Conveyance. Cannot add misc. monthly limit expense on this date.",
      });
      setError(true);
    } else {
      setError(false);
    }
  };

  const handleAmountChange = (e) => {
    const enteredAmount = e.target.value;

    const permissionValue = parseFloat(
      userPermissions.find(
        (permission) =>
          permission.head_id === head.head_id && permission.sub_head_id === "0"
      )?.value || 0
    );

    const amount = parseFloat(enteredAmount);

    if (amount > permissionValue) {
      setAmountError(`Amount cannot exceed ₹${permissionValue}`);
      setFormData({
        ...formData,
        amount: permissionValue.toString(),
      });
    } else {
      setAmountError("");
      setFormData({
        ...formData,
        amount: enteredAmount,
      });
    }
  };

  const handleDragOver = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(true);
    } else {
      setIsDocDragging(true);
    }
  };

  const handleDragEnter = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(true);
    } else {
      setIsDocDragging(true);
    }
  };

  const handleDragLeave = (e, type) => {
    e.preventDefault();
    if (type == "image") {
      setIsDraggingOver(false);
    } else {
      setIsDocDragging(false);
    }
  };

  const handleDrop = (e, type) => {
    e.preventDefault();
    setIsDraggingOver(false);
    setIsDocDragging(false);

    const files = Array.from(e.dataTransfer.files);
    const validExtensions = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];
    const isValidFileType = files.every((file) =>
      validExtensions.includes(file.type)
    );

    if (!isValidFileType) {
      setisValidDoc(true);
      return;
    }

    setisValidDoc(false);
    setFormData((prevFormData) => ({
      ...prevFormData,
      document: [...prevFormData.document, ...files],
    }));
  };

  const handleDocumentChange = (e) => {
    const files = Array.from(e.target.files);
    const validExtensions = [
      "image/jpeg",
      "image/jpg",
      "image/png",
      "application/pdf",
    ];
    const isValidFileType = files.every((file) =>
      validExtensions.includes(file.type)
    );

    if (!isValidFileType) {
      setisValidDoc(true);
      return;
    }

    setisValidDoc(false);
    setFormData((prevFormData) => ({
      ...prevFormData,
      document: [...prevFormData.document, ...files],
    }));
  };

  const handleDeleteDocument = async (index) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        document: prevFormData.document.filter((_, i) => i !== index),
      }));
    }
  };

  const handleExistingDocDelete = async (expImage) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this data!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "Cancel",
    });

    if (result.isConfirmed) {
      utils
        .callAPI("get", `expense/document-delete?id=${expImage?.id}`, "")
        .then((res) => {
          if (typeof res !== "undefined") {
            // getMeetings();

            const updatedExpenseImages = updateExp.expense_image.map((img) =>
              img.id === expImage.id ? { ...img, isDelete: true } : img
            );

            const updatedExp = {
              ...updateExp,
              expense_image: updatedExpenseImages,
            };

            dispatch(setExp(updatedExp));
          }
        })
        .catch((err) => {});

      // // Call delete API
      // utils
      //   .callAPI("post", `/expense/deleteDocument`, {
      //     documentId: updatedDocs[index].id,
      //   })
      //   .then((res) => {
      //     if (res.success) {
      //       Swal.fire("Deleted!", "The file has been deleted.", "success");
      //       dispatch(
      //         clearExp() // Optional: Update redux state if needed
      //       );
      //     } else {
      //       Swal.fire("Failed!", "Something went wrong.", "error");
      //     }
      //   });
    }
  };

  return (
    <RB.Card>
      <RB.Card.Body>
        <h5>{head.head_name}</h5>
        <RB.Form noValidate validated={validated} onSubmit={handleSubmit}>
          <RB.Row>
            <RB.Col md={6} className="mb-3">
              <RB.FloatingLabel
                controlId="formNatureOfExpense"
                label="Nature Of Expense"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  placeholder="Nature Of Expense"
                  value={formData.natureOfExpense}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      natureOfExpense: e.target.value,
                    })
                  }
                  required
                />
              </RB.FloatingLabel>
            </RB.Col>
            {/* <RB.Col md={6} className="mb-3 mt-3">
              <RB.FloatingLabel
                controlId="formDate"
                label="Date"
                className={`floating-label-fancy ${
                  formData.date ? "dateSelected" : "dateempty"
                }`}
              >
                <DatePicker
                  selected={formData.date}
                  onChange={handleDateChange}
                  dateFormat="dd-MM-yyyy"
                  className="form-control"
                  showMonthDropdown
                  showYearDropdown
                  required
                  dropdownMode="select"
                  minDate={new Date()}
                />
              </RB.FloatingLabel>
            </RB.Col> */}
            <RB.Col md={6} className="mb-3">
              <RB.FloatingLabel
                controlId="formAmount"
                label="Amount"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  placeholder="Amount"
                  value={formData.amount}
                  onChange={handleAmountChange}
                  onInput={(e) =>
                    (e.target.value = e.target.value.replace(/[^0-9.]/g, ""))
                  }
                  required
                />
                {amountError && (
                  <div className="invalid-feedback d-block">{amountError}</div>
                )}
              </RB.FloatingLabel>
            </RB.Col>
            <RB.Col md={6} className="mb-3">
              <RB.FloatingLabel
                controlId="formDescription"
                label="Description"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  as="textarea"
                  type="text"
                  placeholder="Description"
                  value={formData.description}
                  onChange={(e) =>
                    setFormData({ ...formData, description: e.target.value })
                  }
                />
              </RB.FloatingLabel>
            </RB.Col>
          </RB.Row>
          <RB.Row className="mt-2">
            <RB.Col className="text-start">
              <h6 className="mt-2">
                Total: ₹ {formData.amount ? formData.amount : 0}
              </h6>
            </RB.Col>
          </RB.Row>
          <RB.Row>
            <RB.Col md={6}>
              <RB.Card className="mb-0">
                <RB.CardBody className="p-2">
                  <h6 className="mb-2">Upload Bills</h6>
                  <hr />
                  <div
                    className={`border p-4 text-center d-flex flex-column align-items-center ${
                      isDocDragging ? "bg-info" : ""
                    }`}
                    onDragOver={(e) => handleDragOver(e, "doc")}
                    onDragEnter={(e) => handleDragEnter(e, "doc")}
                    onDragLeave={(e) => handleDragLeave(e, "doc")}
                    onDrop={(e) => handleDrop(e, "doc")}
                  >
                    <div className="avatar avatar-circle avatar-lg bg-light text-dark">
                      <i className="material-icons-outlined">cloud_upload</i>
                    </div>
                    <p className="mb-0">Drag & Drop your bills here</p>
                    <small className="mb-2">or</small>
                    <div>
                      <input
                        type="file"
                        accept=".jpg,.jpeg,.png,.pdf"
                        multiple
                        style={{ display: "none" }}
                        onChange={handleDocumentChange}
                        id="docInput"
                      />
                      <RB.Button
                        variant="primary"
                        className="me-2"
                        onClick={() =>
                          document.getElementById("docInput").click()
                        }
                      >
                        <i className="las la-file-upload me-1"></i>Browse Bills
                      </RB.Button>
                    </div>
                  </div>
                  <span className={`${isValidDoc ? "text-danger" : ""}`}>
                    <small>
                      *Note: Only jpg,jpeg,png and pdf Files are allowed
                    </small>
                  </span>
                  <RB.Row className="mt-3 g-3"></RB.Row>
                </RB.CardBody>
              </RB.Card>
              {isImage && (
                <div className="text-danger">
                  Please upload at least one bill document.
                </div>
              )}
            </RB.Col>
            <RB.Col md={6}>
              <RB.Row>
                {formData?.document?.map((doc, index) => (
                  <RB.Col md={4} key={index}>
                    <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                      <div className="position-relative">
                        {doc.type === "application/pdf" ? (
                          <a
                            href={URL.createObjectURL(doc)}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none text-dark "
                          >
                            <div className="product-image-upload-trael">
                              <i className="material-icons-outlined md-64 mt-4">
                                picture_as_pdf
                              </i>
                            </div>
                          </a>
                        ) : (
                          <div className="product-image-upload-trael">
                            <img
                              src={URL.createObjectURL(doc)}
                              alt={`Image ${index}`}
                              style={{ maxWidth: "100%", maxHeight: "100%" }}
                            />
                          </div>
                        )}
                      </div>
                      <RB.Button
                        variant="danger"
                        className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                        onClick={() => handleDeleteDocument(index)}
                      >
                        <i className="material-icons-outlined">delete</i>
                      </RB.Button>
                    </div>
                  </RB.Col>
                ))}
                {Array.isArray(updateExp.expense_image) &&
                  updateExp.expense_image.length !== 0 && (
                    <>
                      {updateExp?.expense_image
                        ?.filter((img) => !img.isDelete)
                        ?.map((expImage, index) => (
                          <RB.Col md={4} key={`update-exp-image-${index}`}>
                            <div className="position-relative me-2 mb-4 rounded border p-3 text-center">
                              <div className="position-relative">
                                {expImage.expense_image.endsWith(".pdf") ? (
                                  <a
                                    href={expImage.expensePath}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-decoration-none text-dark"
                                  >
                                    <div className="product-image-upload-trael">
                                      <i className="material-icons-outlined md-64 mt-4">
                                        picture_as_pdf
                                      </i>
                                    </div>
                                  </a>
                                ) : (
                                  <div className="product-image-upload-trael">
                                    <img
                                      src={expImage.expensePath}
                                      alt={`Image ${index}`}
                                      style={{
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                      }}
                                    />
                                  </div>
                                )}
                              </div>
                              <RB.Button
                                variant="danger"
                                className="btn btn-sm btn-circle position-absolute top-100 start-50 translate-middle"
                                onClick={() =>
                                  handleExistingDocDelete(expImage)
                                }
                              >
                                <i className="material-icons-outlined">
                                  delete
                                </i>
                              </RB.Button>
                            </div>
                          </RB.Col>
                        ))}
                    </>
                  )}
              </RB.Row>
            </RB.Col>
          </RB.Row>
          <RB.Row className="mt-2">
            <RB.Col className="text-end">
              <RB.Button variant="success" type="submit" disabled={error}>
                Add to List
              </RB.Button>
            </RB.Col>
          </RB.Row>
        </RB.Form>
      </RB.Card.Body>
    </RB.Card>
  );
}

export default MiscMonthlyLimit;
